import { z } from 'zod';
/**
 * Semantic category of a process note. Doubles as the note's colour in the UI
 * (each value maps to a palette entry) AND is fed to the AI analysis as a
 * structured signal — `problem`/`question` convey user-flagged intent, not just
 * decoration. Stored in English; display labels are localised via `t()`.
 */ export const NoteCategorySchema = z.enum([
    'context',
    'problem',
    'question',
    'todo'
]);

//# sourceMappingURL=note-category.schema.js.map